import * as Cesium from "cesium";
import { CesiumMapItem, CesiumMeasurementItem } from "../types/CesiumMapItems";

export function getEntityByMapId(
  viewer: Cesium.Viewer,
  mapId: string,
): Cesium.Entity | null {
  // Check all entities
  const entities = viewer.entities.values;

  for (let i = 0; i < entities.length; i++) {
    const e = entities[i];
    const properties = e.properties?.getValue(
      Cesium.JulianDate.now(),
    ) as CesiumMeasurementItem;
    if (properties && properties.mapId && properties.mapId === mapId) {
      return e;
    }
  }
  // Check all data sources
  const { dataSources } = viewer;
  for (let i = 0; i < dataSources.length; i++) {
    const d = dataSources.get(i);
    const dataSourceEntities = d.entities.values;

    for (let j = 0; j < dataSourceEntities.length; j++) {
      const e = dataSourceEntities[j];
      const props = e.properties?.getValue(
        Cesium.JulianDate.now(),
      ) as CesiumMapItem;
      if (props && props.mapId && props.mapId === mapId) {
        return e;
      }
    }
  }
  return null;
}
